var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{ref:"custom_tx_modal",attrs:{"active":_vm.show}},[(_vm.show)?_c(_vm.currentTransactionPhase,_vm._g({tag:"component",attrs:{"txType":_vm.transactionType}},_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }